export default __webpack_public_path__ + "static/media/02d.edc43777.png";